/***
 *
 *   LINK STYLES
 *   The reference does not underline links by default — it carries them on
 *   colour and a hover transition (see marketing/pricing-section.tsx and the
 *   settings sections). `underline` is opt-in.
 *
 **********/

const Style = {
    base: 'transition-colors duration-150',

    // colour is opt-in via the `color` prop; anything without one gets the brand
    defaultColor: 'text-primary-600 hover:text-primary-700',

    white: 'text-white hover:text-white/80',
    dark: 'text-text-secondary hover:text-text-primary',
    primary: 'text-text-primary hover:text-primary-600',
    secondary: 'text-text-secondary hover:text-primary-600',
    muted: 'text-text-muted hover:text-text-primary',
    brand: 'text-primary-600 hover:text-primary-700',

    underline: 'underline',
};

export default Style;
